import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import { AppState } from "../../core/app/AppReducer";
import { AdultRewards, ChildReward, OoTClassicItemList, OoTReduceItemList } from "../../core/assets/oot/classic/OoTClassicLists";
import NoteButtonTracker from "../NoteButtonTracker";
import TokenItemCounter from "../inventory/items/TokenCounterItem";


interface ItemsTrackerProps {
    itemsObtained?: true
}
const ItemsTracker = (props: ItemsTrackerProps) => {

    let items: Array<any> = OoTClassicItemList;
    let itemsReduce: Array<any> = OoTReduceItemList;
    let itemCount = 6;
    let startIndex = 0;

    let index: Array<number> = [];

    while (startIndex < items.length) {
        index.push(startIndex);
        startIndex += itemCount;
    }

    let itemReduce = useSelector((state: AppState) => state.ui.ootr.main.useItemTrackerReduce);

    if (itemReduce) {
        return <Box>
            <Box display="flex" onContextMenu={(e) => e.preventDefault()} flexDirection="row"
                alignItems={"flex-start"} alignContent={"flex-start"} flexWrap={"wrap"} maxWidth={"300px"} maxHeight={"500px"} >
                {itemsReduce.map((item, i) => {
                    return <Box display={"flex"}>
                        {item({ id: item.title + item.id, isObtained: props.itemsObtained })}
                    </Box>;
                })}
            </Box>
            <NoteButtonTracker areNoteShuffle={false} display="double line horizontal" />
            <Box display={"flex"} flexDirection={"row"} maxWidth={"300px"} flexWrap={"wrap"} marginTop="10px">
                {ChildReward.map((item, i) => {
                    return <Box sx={{}}>{item({})}</Box>;
                })}
                <Box><TokenItemCounter /></Box>
            </Box>
            <Box display={"flex"} flexDirection={"row"} maxWidth={"300px"} flexWrap={"wrap"}>
                {AdultRewards.map((item, i) => {
                    return <Box sx={{}}>{item({})}</Box>;
                })}
            </Box>
        </Box>
    }


    return <Box display="flex" onContextMenu={(e) => e.preventDefault()} flexDirection="column" >

        <Box display="flex" flexDirection="row" flexWrap="wrap" sx={{ flexFlow: "row" }}>
            <Box display="flex" flexDirection="column" justifyContent="flex-start" width="170px" maxHeight="500px" alignItems={"flex-start"} marginRight="20px">

                {index.map((i) => {
                    return <ItemTrackerRow items={items.slice(i, i + itemCount)} />
                })}


                <NoteButtonTracker areNoteShuffle={false} display="double line horizontal" />
            </Box>
            <Box display="flex" flexDirection={"row"}>

                <Box display="flex" flexDirection={"column"}>
                    {AdultRewards.map(reward => {
                        return <Box>{reward({})}</Box>
                    })}
                </Box>
                <Box display="flex" flexDirection={"column"}>
                    {ChildReward.map(reward => {
                        return <Box>{reward({})}</Box>
                    })}
                </Box>
            </Box>

        </Box>
    </Box>
}


export interface ItemTrackerRowProps {
    items: Array<any>
}
const ItemTrackerRow = (props: ItemTrackerRowProps) => {

    let { items } = props;

    return <Box display={"flex"}>
        {items.map((item, i) => {
            return <Box display="flex"
                sx={{ padding: "0", width: '32px !important', height: '32px!important' }}
            ><Box display="flex" justifyContent={"center"}>
                    {item({ id: item.title + item.id })}
                </Box></Box>;
        })}
    </Box>
}


export default ItemsTracker


